/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum FeedType {
	DIRECT = 'DIRECT',
	FOLLOWING = 'FOLLOWING',
	POPULAR = 'POPULAR',
	WELCOME = 'WELCOME',
	FAREWELL = 'FAREWELL',
}

//==============================================================
// END Enums and Input Objects
//==============================================================

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: FeedTypeSelectorMutation
// ====================================================

export interface FeedTypeSelectorMutation_updateUserPreferences {
	feedType: FeedType | null;
}

export interface FeedTypeSelectorMutation {
	updateUserPreferences: FeedTypeSelectorMutation_updateUserPreferences;
}

export interface FeedTypeSelectorMutationVariables {
	feedType: FeedType;
}
